import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { validateField } from './validatorFunctions';

class ValidationsStore {

    @observable
    public validator: any;

    @observable
    public loaded: boolean = false;

    constructor() {
        this.validator = {}
    }

    @action
    public startValidator = (obj: any) => {
        this.validator = obj;
        this.loaded = true;
    }

    @action
    public resetValidator = () => {
        this.validator = {};
        this.loaded = false;
    }

    @action
    public runValidator = (property: any, data: any) => {

        if (this.validator[property]) {
            const activeProp = this.validator[property];

            const results = activeProp.validateFunctions.filter((f: any) => f.active).map((func: any) => {
                const valid = validateField(func, data);
                return { error: !valid, errorMessage: valid ? '' : func.errorMessage }
            });
            const fieldIsValid = results.every((r: any) => !r.error)
            this.validator[property].valid = fieldIsValid,
                this.validator[property].errorMessage = fieldIsValid ? '' : results.filter((r: any) => r.errorMessage !== '').map((r: any) => r.errorMessage)
            return true
        }
        else {
            return true
        }

        // console.log(toJS(this.validator))
        // for (const key in this.validator) {
        //     if (this.validator.hasOwnProperty(key)) {
        //         console.log(toJS(this.validator[key]))

        //     }
        // }
    }

}

export default new ValidationsStore();


// WEBPACK FOOTER //
// ./src/modules/validations/validations.store.ts